/* eslint-disable-next-line no-redeclare */
/* global window, document */
import {
  useState,
  useEffect
} from 'react';
import getChargebeeSiteId from '../../utils/getChargebeeSiteId';

const initalizeChargebee = (callback) => {
  if (window.Chargebee) {
    return callback(getChargebeeSiteId(), process.env.NEXT_PUBLIC_CHARGEBEE_PUBLISHABLE_KEY);
  }

  const script = document.createElement('script');
  script.setAttribute('src', 'https://js.chargebee.com/v2/chargebee.js');
  script.setAttribute('data-cb-site', getChargebeeSiteId());
  script.onload = () => {
    callback(getChargebeeSiteId(), process.env.NEXT_PUBLIC_CHARGEBEE_PUBLISHABLE_KEY);
  };
  document.body.appendChild(script);
};

const useChargebee = () => {
  const [cbInstance, setCbInstance] = useState(null);

  useEffect(() => {
    initalizeChargebee((site, publishableKey) => {
      window.Chargebee.tearDown();
      setCbInstance(window.Chargebee.init({
        site,
        publishableKey,
        iframeOnly: true, // force Widget to open in same tab
        isItemsModel: true // needed for Chargebee Catalog v2.0
      }));
    });
  }, []);

  return cbInstance;
};

export default useChargebee;
